export default __webpack_public_path__ + "static/media/mouse.dfeff54d.svg";